export const updateSubscriptionUpsellWidget = (data: boolean) =>
  fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/surface/SubscriptionTicketSurface/UpdateSubscriptionUpsellWidget`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      value: data,
    }),
  });
